(function () {
  document.addEventListener('turbo:load', function () {
    I18n.locale = document.body.dataset.locale
  })
}).call(this)
